import React from 'react';

const ExclamationIcon = ({ width = 20, height = 20, fill = '#5F6368' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 -8.74228e-07C15.523 -3.91392e-07 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 3.91392e-07 15.523 8.74228e-07 10C1.35706e-06 4.477 4.477 -1.35706e-06 10 -8.74228e-07ZM10 1.2C7.6661 1.2 5.42778 2.12714 3.77746 3.77746C2.12714 5.42778 1.2 7.66609 1.2 10C1.2 12.3339 2.12714 14.5722 3.77746 16.2225C5.42778 17.8729 7.66609 18.8 10 18.8C12.3339 18.8 14.5722 17.8729 16.2225 16.2225C17.8729 14.5722 18.8 12.3339 18.8 10C18.8 7.66609 17.8729 5.42778 16.2225 3.77746C14.5722 2.12714 12.3339 1.2 10 1.2ZM10.6 12L9.4 12L9.4 5L10.6 5L10.6 12ZM10 13C10.2652 13 10.5196 13.1054 10.7071 13.2929C10.8946 13.4804 11 13.7348 11 14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15C9.73478 15 9.48043 14.8946 9.29289 14.7071C9.10536 14.5196 9 14.2652 9 14C9 13.7348 9.10536 13.4804 9.29289 13.2929C9.48043 13.1054 9.73478 13 10 13Z"
                fill={fill}
            />
        </svg>
    );
};

export default ExclamationIcon;